import React from "react";

import { TableRow, TableCell } from "@material-ui/core";

export const RecetasDigitalesHistorialMedicamento = (props) => {
  const { medicamento } = props;

  return (
    <React.Fragment>
      <TableRow>

        <TableCell component="th" scope="row">{medicamento?.idMedicamento}</TableCell>
        <TableCell>{medicamento?.medicamento.presentacion}</TableCell>
        <TableCell>{medicamento?.medicamento.laboratorio}</TableCell>
        <TableCell>{medicamento?.medicamento.nombre}</TableCell>
        <TableCell>{medicamento?.medicamento.drogas}</TableCell>
        <TableCell align="right">{medicamento.cantidad}</TableCell>
        <TableCell>{medicamento.dosis}</TableCell>
        <TableCell>{medicamento.posologia}</TableCell>
      </TableRow>
    </React.Fragment>
  );
};
